import { IPage } from '@types'
import Layout from 'components/layouts/Layout'
import PartnerView from 'components/partners/PartnerView'
import { getAbout } from 'lib/getAbout'
import { getMenus } from 'lib/getMenus'
import { setCacheControl } from 'lib/misc'
import { isAbsent, isNotString, isSame } from 'lib/utils'
import {
  GetServerSidePropsContext,
  InferGetServerSidePropsType,
} from 'next'

import { IGetAboutResult, IMenuItem } from 'store/api'

export const getServerSideProps = async ({
  req,
  params,
  res,
}: // eslint-disable-next-line @typescript-eslint/require-await
GetServerSidePropsContext) => {
  // Stop from running on client
  const isFirstServerCall = isSame(
    req?.url?.indexOf('/_next/data/'),
    -1
  )

  const emptyProps = {
    partner: {} as IGetAboutResult,
    menus: {} as Record<string, IMenuItem[]>,
  }

  if (!isFirstServerCall)
    return {
      props: emptyProps,
    }

  const slug = params?.['slug'] as string | undefined

  if (isNotString(slug))
    return {
      props: emptyProps,
      notFound: true,
    }

  let about = await getAbout('ru')
  let partner = about.find(
    (i) => i.type === 'partner' && i.slug === slug!
  )

  if (isAbsent(partner)) return { props: emptyProps, notFound: true }

  setCacheControl(res)

  const menus = await getMenus('ru')

  return {
    props: {
      partner,
      menus,
    },
  }
}

export type PartnerPageProps = Required<
  InferGetServerSidePropsType<typeof getServerSideProps>
>

const PartnerPage: IPage<PartnerPageProps> = (props) => (
  <PartnerView {...props} />
)

PartnerPage.getLayout = (page: { props: PartnerPageProps }) => (
  <Layout
    index
    menus={page.props.menus}
    title={page.props?.partner.name}
  >
    {page}
  </Layout>
)

export default PartnerPage
